module.exports = __webpack_public_path__ + "img/Header4Kopf.8cd50039.jpg";